import React, { useState, useEffect, useRef } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";
import Loader from "../../../../Components/Loader/Loader";
import { guardarMarca, editarMarca } from "../../../../../API/IT/MarcaProducto/MarcaProductoRequest";

const MarcasCRUD = ({
  listMarcas,
  marca,
  marcaDialog,
  setMarcaDialog,
  toastRef,
  getPos,
  modo,
}) => {
  const toastDialog = useRef(null);

  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdMarca: -1,
    Marca:""
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    setValues({
      ...marca,
      IdMarca: marca?.IdMarca,
      SSID: marca?.Marca
    });

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Marca) {
      error.Marca = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const verificarDuplicado = () => {
    const duplicado = listMarcas.find((r) => r.IdMarca !== values.IdMarca &&
        (r.IP === values.Marca)
    );

    if (duplicado) {
      let mensaje = "Ya existe una marca con el mismo valor de: ";
      if (duplicado.Marca === values.Marca) mensaje += `Marca ${duplicado.Marca} `;
      return mensaje;
    }

    return null;
  };

  const agregarMarca = async () => {
    const e = verificarInfo();

    if (!e.error) {
      const duplicado = verificarDuplicado();

      if (duplicado) {
        toastShow(toastRef, "error", "Error", duplicado);
        return;
      }

      const a = {
        IdMarca: values?.IdMarca,
        Marca: values.Marca
      };

      if (a.IdMarca > 0) {
        setLoading(true);
        const resultado = await editarMarca(a);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toastRef,
            "success",
            "Datos Editados",
            resultado[0]?.MENSAJE
          );
          getPos();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastRef, "error", "Error", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await guardarMarca(a);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toastRef,
            "success",
            "Datos Agregados",
            resultado[0]?.MENSAJE
          );
          getPos();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toastRef, "error", "Error", resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const onHide = () => {
    setMarcaDialog(false);
    resetForm();
    setShow(false);
  };

  useEffect(() => {
    if (marcaDialog) {
      getValoresIniciales();
    }
  }, [marcaDialog]);

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarMarca();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  const dialogTitle = modo === "Crear" ? "Nueva Marca" : "Modificar Marca";

  return (
    <div>
      <Toast ref={toastRef} />
      <ConfirmDialog />
      <Dialog
        visible={marcaDialog}
        modal
        className="modal__contenedor1"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{margin: "auto" }}>
            {/* <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div> */}
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor">
              <div className="field col-12">
                <span className="p-float-label">
                  <InputText
                    name="Marca"
                    value={values.Marca}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Marca ? "p-invalid" : ""}
                  />
                  <label htmlFor="Marca">Marca</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default MarcasCRUD;
